import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLang, T } from "../../lib/i18n";

const GALA_DATE = new Date("2026-12-31T21:00:00-04:00");

const diff = () => {
  const ms = GALA_DATE - new Date();
  if (ms <= 0) return null;
  return {
    d: Math.floor(ms / 86400000),
    h: Math.floor((ms / 3600000) % 24),
    m: Math.floor((ms / 60000) % 60),
    s: Math.floor((ms / 1000) % 60),
  };
};

export const Countdown = () => {
  const [t, setT] = useState(diff);
  const { lang } = useLang();
  const l = T[lang].countdown;

  useEffect(() => {
    const id = setInterval(() => setT(diff()), 1000);
    return () => clearInterval(id);
  }, []);

  if (!t) return null;
  const cells = [
    [t.d, l.days],
    [t.h, l.hours],
    [t.m, l.min],
    [t.s, l.sec],
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 1.2 }}
      data-testid="hero-countdown"
      className="mt-10 flex items-center gap-3 md:gap-5 flex-wrap"
    >
      <span className="text-[#7BDFF2] text-[11px] md:text-xs uppercase tracking-[0.3em] w-full md:w-auto md:mr-2">{l.title}</span>
      {cells.map(([v, label], i) => (
        <div
          key={label}
          className="backdrop-blur-xl bg-white/10 border border-white/20 rounded-2xl px-4 py-3 md:px-6 md:py-4 text-center min-w-[68px] md:min-w-[88px]"
        >
          <span className="block font-serif text-white text-2xl md:text-4xl tabular-nums leading-none" data-testid={`countdown-${["days","hours","min","sec"][i]}`}>
            {String(v).padStart(2, "0")}
          </span>
          <span className="block text-white/60 text-[10px] md:text-[11px] uppercase tracking-[0.2em] mt-1.5">{label}</span>
        </div>
      ))}
    </motion.div>
  );
};
